export const ACCESS_TOKEN_PREF = "dc.access-token2";
